import {Route} from 'react-router-dom';
import NewOrder from './NewOrder';

export default (
    <Route component={NewOrder} />
);
